import './Home.scss';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import HomeNav from './HomeNav';
import Footer from './Components/Footer/Footer';
import RoundedButton from '../../Components/RoundedButton/RoundedButton';
import HelpOfferSection from './Components/HelpOfferSection';
import SpiderWebSection from './Components/SpiderWebSection';
import BannerSection from './Components/BannerSection';
import ProcessCard from './Components/ProcessCard';
import LogoSection from './Components/LogoSection';
import Background, { BackgroundElement } from './Components/Background';
import { OpenDemoLink } from '../../Components/Utilities/HelperFunctions';

// Media
import SwirlyLines1 from '../../Images/Home/swirly_lines_1.png';
import SwirlyLines2 from '../../Images/Home/swirly_lines_2.png';
import SwarmWave from '../../Images/Home/swarm_wave.png';
// import ParticleWaveClip from '../../Videos/blue_partcles_futuristic.mov';
import HelpOffer1 from '../../Images/Home/help_offer_1.png';
import ProcessImage1 from '../../Images/Home/process_card_1.png';
import ProcessImage2 from '../../Images/Home/process_card_2.png';
import ProcessImage3 from '../../Images/Home/process_card_3.png';
import FinanceWeb from '../../Images/Home/xpektor_web_finance.png';

export default function Landing() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = 'Xpektor';
  }, []);

  return (
    <div className="xpektor-home">
      <div className="landing-intro">
        <HomeNav />
        <div className="section intro-section">
          <h1>{t('landing-page.landing-intro.header')}</h1>
          <p className="section-text">{t('landing-page.landing-intro.para')}</p>
          <RoundedButton
            text={t('landing-page.landing-intro.btn')}
            fillCyan
            onClick={OpenDemoLink}
          />
        </div>
      </div>
      <Background color1="#000B4F">
        <div className="section-with-element">
          <div className="section landing-2">
            <p className="section-title">{t('landing-page.landing-2.title')}</p>
            <h2>{t('landing-page.landing-2.header')}</h2>
            <p className="section-text">{t('landing-page.landing-2.para')}</p>
          </div>
          <BackgroundElement img={SwirlyLines1} yPos={-200} />
        </div>
        {/* <div className="section video-section">
          <video autoPlay muted loop>
            <source src={ParticleWaveClip} />
          </video>
        </div> */}
        <div className="section-with-element">
          <HelpOfferSection
            image={HelpOffer1}
            pTitle={t('shared.help-offer-section.p-title')}
            title={t('shared.help-offer-section.title')}
            points={[
              ...t('shared.help-offer-section.shared-points', {
                returnObjects: true,
              }),
            ]}
            btnText={t('shared.book-demo')}
          />
          <BackgroundElement img={SwirlyLines2} yPos={400} />
        </div>
      </Background>
      <Background color1="#000B4F" color2="#010024">
        <div className="section-with-element">
          <SpiderWebSection
            pTitle={t('shared.spider-web-section.p-title')}
            title={t('shared.spider-web-section.title')}
            text={t('shared.spider-web-section.text')}
            btnText={t('shared.read-more')}
            image={FinanceWeb}
          />
          <BackgroundElement img={SwarmWave} yPos={700} />
        </div>
        <div className="section home-4">
          <p className="section-title">
            {t('landing-page.process-section.p-title')}
          </p>
          <h2>{t('landing-page.process-section.header')}</h2>
          <div className="row-content">
            <ProcessCard
              image={ProcessImage1}
              title={t('landing-page.process-section.process-cards.pc0.title')}
              text={t('landing-page.process-section.process-cards.pc0.text')}
            />
            <ProcessCard
              image={ProcessImage2}
              title={t('landing-page.process-section.process-cards.pc1.title')}
              text={t('landing-page.process-section.process-cards.pc1.text')}
            />
            <ProcessCard
              image={ProcessImage3}
              title={t('landing-page.process-section.process-cards.pc2.title')}
              text={t('landing-page.process-section.process-cards.pc2.text')}
            />
          </div>
        </div>
        <div className="section-with-element">
          <LogoSection />
          <BackgroundElement img={SwirlyLines2} yPos={-300} />
        </div>
      </Background>
      <Background end>
        <BannerSection />
        <Footer darkMode />
      </Background>
    </div>
  );
}
